import { render, staticRenderFns } from "./Vue-Upload.vue?vue&type=template&id=27ee91c1&"
import script from "./Vue-Upload.vue?vue&type=script&lang=js&"
export * from "./Vue-Upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports